export default function Sun() {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Sun icon</title>
      <g>
        <path
          d="M33.0357 51.1603C22.8807 51.1603 14.8396 43.0192 14.8396 32.7357C14.8396 22.9807 23.1235 14.8396 33.0499 14.8396C43.0621 14.8396 51.1889 23.0807 51.1746 33.1928C51.1746 42.9906 42.9192 51.1603 33.0357 51.1603ZM44.576 33.1642C44.6046 26.6228 39.5343 21.4667 33.0785 21.4239C26.6799 21.381 21.4239 26.5371 21.4382 32.8357C21.4382 39.42 26.4514 44.5332 32.9357 44.576C39.3057 44.6332 44.5617 39.4771 44.5903 33.1642H44.576Z"
          fill="#010101"
        />
        <path
          d="M61.0297 36.4635C59.9585 36.2492 58.8016 36.2349 57.8304 35.7922C56.5592 35.2209 55.9736 33.9783 56.1878 32.5929C56.3878 31.236 57.1591 30.1363 58.5873 29.9077C59.9585 29.6935 61.3867 29.6649 62.7721 29.7363C64.8146 29.8506 66.0571 31.2646 65.9857 33.1642C65.9143 34.9495 64.6146 36.1635 62.6293 36.2921C62.1009 36.3206 61.5724 36.2921 61.0439 36.2921C61.0439 36.3492 61.0154 36.4063 61.0154 36.4635H61.0297Z"
          fill="#010101"
        />
        <path
          d="M29.7222 60.9725C29.6793 57.7732 30.7934 56.1307 32.9643 56.1022C35.121 56.0736 36.3065 57.7875 36.3065 60.9297C36.3065 61.6295 36.3493 62.3437 36.2636 63.0292C36.0208 64.8717 34.6925 66.0143 32.9358 65.9857C31.2361 65.9572 29.9935 64.8574 29.7507 63.0721C29.6508 62.3865 29.7365 61.6724 29.7365 60.9725H29.7222Z"
          fill="#010101"
        />
        <path
          d="M29.7222 4.78466C29.7222 4.14194 29.6365 3.48494 29.7365 2.8565C29.9935 1.18544 31.2218 0.0856752 32.8072 -2.05385e-05C34.5354 -0.0857163 35.9208 0.885502 36.1636 2.65655C36.3636 4.08481 36.3493 5.58449 36.1922 7.01275C36.0208 8.65525 34.4354 9.89784 32.9072 9.85499C31.4075 9.81214 30.0507 8.64097 29.765 7.04131C29.6365 6.29862 29.6793 5.52735 29.6365 4.77038C29.665 4.77038 29.6793 4.77038 29.7079 4.77038L29.7222 4.78466Z"
          fill="#010101"
        />
        <path
          d="M4.95607 36.2778C4.31335 36.2778 3.65635 36.3349 3.02792 36.2778C1.18546 36.0636 0 34.7638 0 33.0071C0 31.3074 1.04263 29.9934 2.82796 29.7935C4.15624 29.6364 5.52738 29.6507 6.85566 29.7649C8.61242 29.9363 9.89786 31.436 9.85501 33.0785C9.82645 34.7067 8.4696 36.0921 6.69855 36.2635C6.11296 36.3206 5.52738 36.2635 4.94179 36.2635L4.95607 36.2778Z"
          fill="#010101"
        />
        <path
          d="M48.2753 14.654C48.618 12.4402 51.9173 8.4982 53.8169 8.58389C54.8738 8.62674 56.1164 9.34087 56.8877 10.1407C57.8018 11.0834 57.7018 12.4973 56.8306 13.54C55.8308 14.754 54.7596 16.0109 53.4599 16.8535C52.6886 17.3534 51.2461 17.482 50.4034 17.0963C49.5036 16.6964 48.9608 15.4967 48.261 14.654H48.2753Z"
          fill="#010101"
        />
        <path
          d="M14.8825 17.5962C12.3973 17.5676 8.7267 14.0826 8.92666 12.2259C9.02664 11.2404 9.62651 9.95496 10.3978 9.48363C11.2404 8.98374 12.8115 8.8552 13.6114 9.32652C14.9682 10.1263 16.2251 11.3832 17.0535 12.7401C17.5391 13.5399 17.4105 15.0681 16.9678 15.9679C16.5536 16.8106 15.3396 17.2677 14.8825 17.5962Z"
          fill="#010101"
        />
        <path
          d="M8.38391 54.4454C8.75526 52.2316 12.1117 48.6181 14.0113 48.818C15.0253 48.9323 16.3965 49.6036 16.8249 50.432C17.2963 51.3318 17.2391 52.8886 16.7535 53.8169C16.1394 55.0024 14.9254 55.9165 13.8542 56.802C12.8258 57.6447 11.4975 57.8161 10.4406 57.002C9.59793 56.3592 9.06948 55.3023 8.39819 54.4454H8.38391Z"
          fill="#010101"
        />
        <path
          d="M54.1883 57.2305C52.4458 57.2305 49.1037 54.4025 49.2322 52.7172C49.3179 51.646 50.0035 50.3891 50.8176 49.6607C51.7603 48.8037 53.1171 48.9037 54.2169 49.7607C55.0024 50.3748 55.788 51.0033 56.4735 51.7174C57.4162 52.7172 57.8161 53.8884 57.2019 55.2595C56.6164 56.5592 55.6451 57.2733 54.1883 57.2448V57.2305Z"
          fill="#010101"
        />
      </g>
    </svg>
  );
}
